export function getEnvironmentLabel(): string {
  const hostname = window.location.hostname;
  if (hostname === 'localhost' || hostname === '127.0.0.1') return ' - LOCAL';
  if (hostname.includes('dev.')) return ' - DEV';
  if (hostname.includes('qa.')) return ' - QA';
  if (hostname.includes('uat.')) return ' - UAT';
  return '';
}
